var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext } from "react";
import { Button } from "../Button";
import { CollapseContext } from "../../core";
var DropdownMenuButton = forwardRef(function (_a, ref) {
    var icon = _a.icon, iconSvg = _a.iconSvg, disabled = _a.disabled, onClick = _a.onClick, children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["icon", "iconSvg", "disabled", "onClick", "children", "className", "style"]);
    var btnClass = "ssg-dropdown-menu__btn";
    if (className) {
        btnClass += " " + className;
    }
    var collapseContextValue = useContext(CollapseContext);
    var closeCollapse = undefined;
    if (collapseContextValue) {
        closeCollapse = collapseContextValue.closeCollapse;
    }
    var onClickButton = function (event) {
        if (closeCollapse) {
            closeCollapse();
        }
        if (onClick) {
            onClick(event);
        }
    };
    return (React.createElement(Button, __assign({}, otherProps, { ref: ref, variant: "tertiary-no-outline", className: btnClass, style: style, icon: icon, iconSvg: iconSvg, iconPosition: icon || iconSvg ? "left" : undefined, disabled: disabled, onClick: onClickButton }), children));
});
export default DropdownMenuButton;
